import React from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { setBecome } from "../../sagas/actions";
import { useNavigate } from "react-router-dom";
import { unbecomeUser } from "../../sagas/actions";

const Container = styled.div`
  font-family: Arial, sans-serif, verdana, helvetica;
  font-size: 90%;
  margin: 0;
  background: red;
  text-align: right;
  padding: 7px 20px;
  font-weight: bold;
`;

const Link = styled.a`
  color: white;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export default function ZoomOutUser() {
  const dispatch = useDispatch();
  const origin = useSelector((state) => state.auth.become_origin);
  const navigate = useNavigate();
  const handleZoom = () => {
    if (origin === "directory") {
      dispatch(setBecome(0));
      dispatch(unbecomeUser());
      navigate('/admincentral/orgs/search', { state: { initialTab: "User Search" } });
    } else {
      dispatch(unbecomeUser());
      navigate('/admincentral/teachers');
    }
  }
  return (
    <Container>
      <Link onClick={() => handleZoom()}>Zoom out</Link>
    </Container>
  );
}
